import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { SharedService } from "../../../Services/shared.service";
import { EmployeeFilterOptions } from './interface';

export class Store<T>{
    private state$ : BehaviorSubject<EmployeeFilterOptions[]>;
    protected constructor( initialState : EmployeeFilterOptions[] =[]){
         this.state$ = new BehaviorSubject(initialState);
    }

    get getValue(): EmployeeFilterOptions[]{
        return this.state$.getValue();
    }
   get getState(): Observable<EmployeeFilterOptions[]>{
        return this.state$.asObservable();
    }
   set setState(item: EmployeeFilterOptions[]){
        this.state$.next(item);
    }
}

@Injectable()


export class FilteredEmployees extends Store<EmployeeFilterOptions[]>{
  lastUpdate: any;
    constructor(
        private share: SharedService
      ) {
        super();
        this.lastUpdate =1627643972000;
      }

      set addColumns(newItem:any){
          let currentTMS = new Date().getTime();
          let diff = (currentTMS - this.lastUpdate)/1000/60;

          if(diff > 30){
            //  console.log('Call Api');
          }else{
            
             this.setState
            // console.log('NEW ITEM ', newItem);

          }
      }

     get columns(): EmployeeFilterOptions[] {
        return this.getValue;
      }
     get listen(): Observable<EmployeeFilterOptions[]> {
        return this.getState;
      }
}